module.exports = __webpack_public_path__ + "static/media/Hello.a70723b3.png";